(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'SensitiveData',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#sensitivedata-tokenize_sensitive_data').click(function checkIfUnchecking() {
			if ($(this).prop('checked') === false) {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'By unchecking this, be aware that any sensitive data that has been stored will be removed from CP Maxx for your franchise. Do you want to continue?',
					cancel : function cancel() {
						$('#sensitivedata-tokenize_sensitive_data').prop('checked', true);
					}
				});
			}
		});
	};
}(jQuery, window.Adzuki || {}));
